import { FetchApiResponse } from "redux/types";

export enum BuyerSellerDumpReportReduxTypes {
    BUYER_SELLER_DUMP_REPORT = "@@auth/BUYER_SELLER_DUMP_REPORT",
    BUYER_SELLER_DUMP_REPORT_SUCCESS = "@@auth/BUYER_SELLER_DUMP_REPORT_SUCCESS",
    BUYER_SELLER_DUMP_REPORT_ERROR = "@@auth/BUYER_SELLER_DUMP_REPORT_ERROR"
}

export type BuyerSellerDumpReportActionDispatch = {
    type: | BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT;
    payload: any;
}

export type BuyerSellerDumpReportReducerDispatch = {
    type: | BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT
    | BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT_SUCCESS
    | BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT_ERROR

    payload: {
        data?: FetchApiResponse<BuyerSellerDumpReport>
        error?: string
    }
}

export type BuyerSellerDumpReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type BuyerSellerDumpReportRequest = {
    payload: {},
    type: string
}

export type CreateBuyerSellerDumpReportReduxState = {
    loading?: boolean
    data?: {},
    error?: string | null;
}